/*
 * Copyright (c) GM Global Technology Operations LLC. All rights reserved.
 * This information is confidential and proprietary to GM Global Technology
 * Operations LLC and may not be used, modified, copied or distributed.
 */

import Email from '@mui/icons-material/Email';
import Home from '@mui/icons-material/Home';
import { Box, Button, Grid2, Typography } from '@mui/material';

interface UnauthorizedProps {
  redirectUrl: string;
}

export const Unauthorized = (props: UnauthorizedProps) => {
  return (
    <Grid2 container spacing={0} direction={'column'} justifyContent="center" alignItems="center">
      <Box sx={{ padding: '1em' }}>
        <Typography>To get access, please contact the Motorsports Distro group</Typography>
      </Box>
      <Box>
        <Button variant="contained" href={`mailto:${process.env.REACT_APP_SUPPORT_EMAIL}`} sx={{ mr: '10px' }}>
          <Email sx={{ mr: '5px' }} />
          Request Access
        </Button>
        <Button variant="contained" href={props.redirectUrl}>
          <Home sx={{ mr: '5px' }} />
          Go Home
        </Button>
      </Box>
    </Grid2>
  );
};
